import React, { useState } from 'react';
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import Icon from '@mdi/react';

export default (props: {
    handleChangeInput: (value: string) => void;
    password: string;
    error: boolean;
    placeholder: string;
}) => {
    const { handleChangeInput, password, error, placeholder } = props;

    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextField
            type={showPassword ? 'text' : 'password'}
            size='small'
            value={password}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeInput(e.target.value)}
            error={error}
            placeholder={placeholder}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position='end'>
                            {password !== '' && (
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge='end'
                                >
                                    {showPassword ? (
                                        <Icon path={mdiEyeOutline} size={1} />
                                    ) : (
                                        <Icon path={mdiEyeOffOutline} size={1} />
                                    )}
                                </IconButton>
                            )}
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};
